import { bool, string, func } from 'prop-types'
import Div from '@ui/layout/Div'
import Alert from '@ui/elements/Alert'

const TextareaType = ({
  name,
  value,
  onChange = () => { },
  cssClass,
  label,
  help,
  placeholder,
  disabled = false,
  error,
  isRequired = false
}) => {
  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
      <Div cssClass="control">
        <textarea className='textarea' placeholder={placeholder} id={`input-${name}`} name={name} onChange={onChange} value={value} disabled={disabled} />
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

TextareaType.propTypes = {
  name: string,
  onChange: func,
  cssClass: string,
  disabled: bool,
  help: bool,
  label: string,
  placeholder: string,
  value: string,
  error: string,
  isRequired: bool
}

export default TextareaType
